




import { Component, Prop } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import OpportunityStatus from '@/models/Opportunities/OpportunityStatus';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';

@Component({ name: 'OpportunityStatus' })
export default class extends GiganautVue {
    @Prop({ required: true }) opportunityStatus!: OpportunityStatus;
    @Prop({ required: true }) location!: StatusDisplayLocation;

    get textColor(): string {
        return this.opportunityStatus === OpportunityStatus.Open ? 'green--text' : 'grey--text';
    }

    get text(): string {
        return this.opportunityStatus === OpportunityStatus.Open ? 'OPEN' : 'CLOSED';
    }

    get classy() {
        const classes: string[] = [this.textColor, 'overline'];
        if (this.location !== StatusDisplayLocation.Grid) {
            classes.push('ma-2');
        }
        return classes;
    }
}
